import { Flex } from 'antd'
import PropTypes from 'prop-types'

function FormItems({ children = null }) {
  return <Flex vertical gap="16px" className="form-items-wrapper">
    {children}
  </Flex>
}

FormItems.propTypes = {
  children: PropTypes.node,
}

export default FormItems
